import { useRef, useState, useLayoutEffect } from 'react';
import { interactionSortOptions } from '../../utils';
import useList from './hooks/List';
import Header from './components/Header';
import Toolbar from './components/Toolbar';
import InteractionsModal from './utils/InteractionsModal';
import List from './components/Mobile/List';
import Table from './components/DesktopTable/Table';

const InteractionsList = ({
  score,
  mode,
  userFilter,
  logout,
  permissions = null,
  losesAccess = null,
  message = null,
  className = '',
}) => {
  const vm = useList({
    score,
    mode,
    userFilter,
    logout,
    permissions: permissions ?? [],
    losesAccess,
    message,
  });
  const showResumeMoreLink = mode === 'resume';
  const hasFullResume = mode === 'resume' && !vm.loading && vm.filteredInteractions?.length >= 3;

  const stickyHeaderRef = useRef(null);
  const [stickyOffset, setStickyOffset] = useState(0);

  useLayoutEffect(() => {
    if (mode !== 'principal') return;
    const el = stickyHeaderRef.current;
    if (!el) return;
    const observer = new ResizeObserver(() => setStickyOffset(el.offsetHeight));
    observer.observe(el);
    return () => observer.disconnect();
  }, [mode]);

  return (
    <div
      className={`interactions-view activity-history-card ${hasFullResume ? 'profile-card-has-more' : ''} bg-white border border-gray-200 rounded-lg shadow-sm flex flex-col ${mode === 'resume' ? 'h-auto w-full self-start' : 'h-full'} ${className}`}
      style={{ overflow: 'clip' }}
    >
      {/* Scroll de página: este bloque (título + filtros) queda fijo con un pequeño espacio
          arriba (sticky top-3, bajo la capa de fondo) mientras el body de la tabla se desplaza. */}
      <div
        ref={stickyHeaderRef}
        className={mode === 'principal' ? 'md:sticky md:top-3 md:z-20 md:bg-white' : ''}
      >
        <Header
          mode={mode}
          action={showResumeMoreLink ? (
            <a
              href="#"
              className="text-sm font-medium text-personalized hover:underline"
              onClick={(e) => { e.preventDefault(); vm.validAccess(); }}
            >
              Ver Todos
            </a>
          ) : undefined}
        />
        <Toolbar
          mode={mode}
          query={vm.query}
          setQuery={vm.setQuery}
          editable={vm.editable}
          loadingUpdate={vm.loadingUpdate}
          deleteChange={vm.deleteChange}
          handleSaveAllScores={vm.handleSaveAllScores}
        />
      </div>
      <List
        mode={mode}
        query={vm.query}
        message={message}
        loading={vm.loading}
        editable={vm.editable}
        sortConfig={vm.sortConfig}
        editedScores={vm.editedScores}
        loadingUpdate={vm.loadingUpdate}
        setSortColumn={vm.setSortColumn}
        sortOptions={interactionSortOptions}
        handleScoreChange={vm.handleScoreChange}
        toggleSortDirection={vm.toggleSortDirection}
        filteredInteractions={vm.filteredInteractions}
        displayedInteractions={vm.displayedInteractions}
      />
      <Table
        loading={vm.loading}
        filteredInteractions={vm.filteredInteractions}
        displayedInteractions={vm.displayedInteractions}
        query={vm.query}
        mode={mode}
        editable={vm.editable}
        editedScores={vm.editedScores}
        loadingUpdate={vm.loadingUpdate}
        handleScoreChange={vm.handleScoreChange}
        sortConfig={vm.sortConfig}
        handleSort={vm.handleSort}
        stickyOffset={stickyOffset}
      />
      <InteractionsModal
        open={vm.open}
        setOpen={vm.setOpen}
        userFilter={userFilter}
        InteractionsModal={message}
        logout={logout}
      />
    </div>
  );
};

export default InteractionsList;
